<style>

</style>
<template>
	<div class="shopsetting">
		<cube-page title="分销商" :backurl="'/my'">
			<div slot="content">
				<div class="setting-shop" :style="{background:`linear-gradient(${gcfg.BackgroundColor} 50%,#FFF)`}">
					<div class="shop-xx shop-setting" v-if="distributor != null && distributor != undefined"
						:style="'background-color:'+gcfg.BackgroundColor">
						<div class="shop-tx">
							<img :src="distributor.avatar">
						</div>
						<div class="shop-xq-a" :style="'color:#545659'">
							<div class="shop-name">
								<p class="name-p">
									<span class="name ells2">{{distributor.nickname}}</span>
								</p>
								<p class="name">
									<span class="name ells2">ID:{{distributor.id}}</span>
								</p>
							</div>
						</div>
					</div>
					<div class="shop-xx shop-setting" v-else :style="'background-color:'+gcfg.BackgroundColor">
						<div class="shop-tx">
						</div>
					</div>
					<div class="swipemain" :style="'color:'+gcfg.TopTextColor">
						<!-- 系统公告  -->
						<van-swipe style="height: 100px;" :autoplay="3000" :vertical="true" :show-indicators="false">
							<van-swipe-item v-for="(itemlist, key) in list" :key="key">
								<template v-for="(item, index) in itemlist">
									<div :key="index" class="text-content van-ellipsis" @click="gotourl(item)">
										<span>{{ item.title}}</span>
									</div>
								</template>
							</van-swipe-item>
						</van-swipe>
					</div>
				</div>
				<div class="leoshop-content">
					<van-grid :style="'color:'+gcfg.TopTextColor" clickable :column-num="4" :border="false">
						<van-grid-item to="/" style="color: #ff0000;">
							<van-icon name="goods-collect-o" class="van-grid-item__icon" />
							<span class="van-grid-item__text" style="color: #ff0000;font-weight: 600;">底价采购</span>
						</van-grid-item>
						<van-grid-item @click="goSettingPage">
							<van-icon name="setting-o" class="van-grid-item__icon" />
							<span class="van-grid-item__text" style="font-weight: 600;">设置</span>
						</van-grid-item>
            <van-grid-item @click="goOder('0')">
              <van-icon name="records" class="van-grid-item__icon" />
              <span class="van-grid-item__text" style="font-weight: 600;">订单</span>
            </van-grid-item>
					</van-grid>
<!--					<div class="ddbox" v-if="orderGroup !=null">
						<van-cell title="我的订单" is-link value="全部" @click="goOder('0')" />
						<van-grid clickable :column-num="4" :border="false">
							<van-grid-item @click="goOder('1')">
								<van-badge>
									<template #content v-if="orderGroup.NoConfirmNum > 0">
										{{orderGroup.NoConfirmNum }}
									</template>
									<van-icon class="van-grid-item__icon" name="paid" />
								</van-badge>
								<span class="van-grid-item__text">待确认</span>
							</van-grid-item>
							<van-grid-item @click="goOder('2')">
								<van-badge>
									<template #content v-if="orderGroup.NoPayNum > 0">
										{{orderGroup.NoPayNum }}
									</template>
									<van-icon class="van-grid-item__icon" name="pending-payment" />
								</van-badge>
								<span class="van-grid-item__text">待支付</span>
							</van-grid-item>
							<van-grid-item @click="goOder('3')">
								<van-badge>
									<template #content v-if="orderGroup.NoUseNum > 0">
										{{orderGroup.NoUseNum }}
									</template>
									<van-icon name="records" class="van-grid-item__icon" />
								</van-badge>
								<span class="van-grid-item__text">待核销</span>
							</van-grid-item>
							<van-grid-item @click="goOder('4')">
								<van-badge>
									<template #content v-if="orderGroup.FinishNum > 0">
										{{orderGroup.FinishNum }}
									</template>
									<van-icon class="van-grid-item__icon" name="sign" />
								</van-badge>
								<span class="van-grid-item__text">已完成</span>
							</van-grid-item>
						</van-grid>
					</div>-->
					<div>
						<div class="no-ddbox">
							<van-image height="110" :src="imgShare" @click="onQrcode" />
						</div>
						<div class="ddbox">
							<van-cell title="我的分销" />
							<van-grid clickable :column-num="4" :border="false">
								<van-grid-item to="dissetting?n=2">
									<van-badge>
										<van-icon class="van-grid-item__icon" name="descending" />
									</van-badge>
									<span class="van-grid-item__text">我的下级</span>
								</van-grid-item>
								<van-grid-item to="disordernew?n=2">
									<van-badge>
										<van-icon class="van-grid-item__icon" name="orders-o" />
									</van-badge>
									<span class="van-grid-item__text">分销订单</span>
								</van-grid-item>
								<van-grid-item to="dissy?n=2">
									<van-badge>
										<van-icon name="balance-o" class="van-grid-item__icon" />
									</van-badge>
									<span class="van-grid-item__text">分销收益</span>
								</van-grid-item>
								<!-- 	<van-grid-item to="dissetting?n=3">
										<van-badge>
											<van-icon class="van-grid-item__icon" name="setting-o" />
										</van-badge>
										<span class="van-grid-item__text">分销设置</span>
									</van-grid-item> -->
							</van-grid>
						</div>
					</div>
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import {
		Toast
	} from 'vant';
  import {redirect} from "@/utils/network";
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				gcfg: [],
				orderGroup: null,
				distributor: null,
				disGroup: {
					NoConfirmNum: 0,
					NoPayNum: 0,
					NoUseNum: 0,
					FinishNum: 0
				},
				imgShare: null,
				list: [],
			}
		},
		created() {
			this.getShareImages()
			this.getDisData()
			this.getData()
			this.getSysNotice()
			this.gcfg = this.$store.getters.getGcfg
		},
		methods: {
			onQrcode() {
				this.$router.push({
					path: '/qrcode',
					query: {
						n: 2
					}
				})
			},
			goOder(v) {
				this.$router.push({
					path: '/disorder',
					query: {
						showType: v
					}
				})
			},
			//设置页面
			goSettingPage() {
				this.$router.push({
					path: '/disAppr',
					params: {
						bj: 1
					}
				})
			},
			getShareImages() {
				let that = this;
				var url = "/addons/litestore/api.distributor/getShareImages"
				//这里直接调用网络接口
				util.get(url, {},
					function (result) {
						if (result.data != null) {
							that.imgShare = result.data.share_img
						}
					},
				);
			},
			// 获取数据
			getData() {
				let that = this;
				var url = "/addons/litestore/api.distributor/getOrderGroupNum"
				//这里直接调用网络接口
				util.get(url, {},
          function (result) {
              if (result.data != null) {
                that.orderGroup = result.data
              }
					},
          function () {
                redirect('my');
          }
				);
			},
			// 获取公告
			getSysNotice() {
				let that = this;
				var url = "/addons/litestore/api.index/getSysNotice"
				//这里直接调用网络接口
				util.get(url, {
						place: 103
					},
					function (result) {
						that.list = result
					},
				);
			},
			getDisData() {
				let that = this;
				var url = "/addons/litestore/api.account/editDistributor"
				//这里直接调用网络接口
				util.get(url, {},
					function (result) {
						if (result.data != null) {
							that.distributor = result.data
						}
					},
				);
			},
			// 公告跳转
			gotourl(item) {
				console.log(item)
				if (item.url) {
					window.location.href = item.url
				} else {
					this.$router.push({
						path: 'about',
						query: {
							id: item.id
						}
					})
				}
			}

		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			}
		}
	}
</script>
<style>
	.van-grid-item__content,
	.van-cell {
		background: transparent;
		border: none;
	}

	/* 添加这段样式后，Primary Button 会变成红色 */
	:root {
		--van-grid-item-text-color: gcfg.TopTextColor;
	}
</style>
<style lang="less" scoped="scoped">
	@import url("../../../assets/css/listboxless.less");

	.setting-shop {
		position: relative;
		height: auto;
		padding-bottom: 5px;

		.ddbox {
			margin: 10px 0;
			box-sizing: border-box;
			background-color: #FFFFFF;
			border-radius: 15px;
			box-shadow: 0 0 5px #e2e2e2;

			.dditem {
				display: flex;
				align-items: center;
				justify-content: space-around;
				height: 60px;

				p {
					text-align: center;

					span {
						display: block;
						font-size: 13px;
					}

					span:first-child {
						font-size: 20px;
						font-weight: 600;
					}

					.sizesm {
						font-size: 12px;
						color: #aaabaf;
					}
				}
			}

		}

		.field-shopxx {
			height: 100px;
			display: flex;
			justify-content: space-around;
			align-items: center;

			.dditem {
				span:first-child {
					color: rgb(255, 0, 0);
					font-weight: 600;
				}
			}
		}
	}

	.shop-name .name-p {
		margin-bottom: 10px;
		font-weight: bold;
	}

	.grid-box {
		background: #fff;
		border-radius: 5px;
		margin: 15px 0;
		box-shadow: 0 0 5px #e2e2e2;
	}

	.no-ddbox {
		padding-bottom: 10px;
		margin: 10px 10px 0;
	}

	.swipemain {
		width: auto;
		text-align: left;
		border-radius: 5px;
		margin: 10px 0;
		padding: 10px;
		overflow: hidden;
		background: #fff;
		box-shadow: 0 0 5px #e2e2e2;
	}

	.text-content {
		font-size: 12px;
		color: #333;
		margin-bottom: 5px;
	}

	.text-content {
		font-size: 14px;
		color: #333;
		padding: 0;
	}

	/deep/ .van-swipe {
		margin: 0;
		padding: 0;
		height: 90px;
		overflow: hidden;
	}

	/deep/ .van-swipe__indicator {
		background-color: #333;
	}

	.leoshop-content {
		margin-top: 15px;
	}

	.leoshop-content .ddbox {
		margin: 10px 15px 0;
	}

	.shop-xq-a {
		padding-left: 15px;
	}

</style>
